import { Persona, PERSONA_ICON_MAP } from '../BeFi20.meta';

interface GetPersonaIconParams {
  persona: Persona;
  score: number;
}

export const getPersonaIcon = ({ persona, score }: GetPersonaIconParams) => {
  const personaIcon = PERSONA_ICON_MAP[persona];

  return score > 50 ? personaIcon.scored : personaIcon.default;
};
